<div class="modal-content">
    <form (ngSubmit)="submit()" [formGroup]="modalPassForm">
        <div class="modal-body p-5" [ngClass]="confirmData.dynamicClass? confirmData.dynamicClass: ''">
            <div class="row">
                <div class="col-12">
                    <h4><strong>{{confirmData.title || 'Confirm'}}</strong></h4>
                </div>
                <div class="col-12 mt-5">
                    <div class="form-group">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>Ingrese Nueva Contraseña</mat-label>
                            <input matInput class="w-100" formControlName="newPassword" id="password" type="password">
                            <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearControl('newPassword')" *ngIf="modalPassForm.get('newPassword')?.value">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field> 

                        <app-error [control]="modalPassForm.get('newPassword')"></app-error>
                        <span class="mb-3"> <!--showSpanNewPass()-->
                            <p class="mb-0" [ngClass]="validaNewPass() ? 'color-success' : 'color-error'" >La contraseña debe tener:</p>
                            <p class="mb-0" [ngClass]="validaLargo() ? 'color-success' : 'color-error'" >Largo Mínimo 15, Largo Máximo 17</p>
                            <p class="mb-0" [ngClass]="validaCaracteres() ? 'color-success' : 'color-error'" >Se requieren caracteres especiales (+,-;.$?¿¡)</p>
                            <p class="mb-0" [ngClass]="validaMayus() ? 'color-success' : 'color-error'" >Se requieren letras mayúsculas</p>
                            <p class="mb-0" [ngClass]="validaMin() ? 'color-success' : 'color-error'" >Se requieren letras minúsculas</p>
                            <p [ngClass]="validaNum() ? 'color-success' : 'color-error'" >Se requieren números</p>
                        </span>
                    </div>
                    <div class="form-group mt-5">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>Ingrese Nueva Contraseña</mat-label>
                            <input matInput class="w-100" formControlName="confirmPassword" id="confirmPassword" type="password">
                            <button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearControl('confirmPassword')" *ngIf="modalPassForm.get('confirmPassword')?.value">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field> 
                        <span *ngIf="showSpanConfirmPass()" class="text-danger">
                            Las contraseñas deben ser iguales
                        </span>
                        <app-error [control]="modalPassForm.get('confirmPassword')">
                        </app-error>
                    </div>
                </div>
                <div class="col-12 my-3 d-flex justify-content-around">
                    <button mat-flat-button 
                        class="custom-button-secondary-fixed"
                        type="button"
                        (click)="closeModal()"
                        *ngIf="!confirmData.hideCancelmButtom"
                    >
                        {{confirmData.textBoton && confirmData.textBoton.length > 0? confirmData.textBoton[1]: 'Cancelar'}}
                    </button>
                    <button mat-flat-button 
                        class="custom-button-tertiary"
                        type="submit"
                        [disabled]="!validaPass()"
                    >
                        {{confirmData.textBoton && confirmData.textBoton.length > 0? confirmData.textBoton[0]: 'Continuar'}}
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>
